import React from 'react';
import { connect } from 'react-redux';
import { fetchClaims, setOpened, fetchAllClaimWizardPackages, clearClaimWizardPackages, resetClaimWizard } from 'state/actions';
import i18n from 'lib/i18n';
import ClaimsZoom from './claimsZoom';
import ClaimsForm from './form';
import ClaimResults from './claimResults';
import DigitalClaimTable from './digitalClaimTable';
import styles from './claims.scss';

const _ = i18n('claims');

const SubNav = ({ currentId, items, onChange }) => (
	<div className={styles.subNavContainer}>
	  {Object.keys(items).map((moduleId) => (
		<div
		  key={moduleId}
		  className={`${styles.tab} ${currentId === moduleId ? styles.active : ''}`}
		  onClick={() => {
			if (currentId !== moduleId) {
				onChange(moduleId);
			}
		  }}
		>
		  {items[moduleId]}
		</div>
	  ))}
	</div>
);

@connect((state) => {
	const { claims, app: { opened }, claimWizard: { claimWizardPackages } } = state;
	return {
        claims,
        claimNumber: opened,
        expandedItem: opened ? claims.find(i => i.main.claimNumber === opened) : null,
		claimWizardPackages,
        opened,
    };
})
export default class Claims extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showTable: false,
			activeSubtitle: 'schade',
		};
	}

	static propTypes = {
		claims: React.PropTypes.array,
		claimNumber: React.PropTypes.any,
		dispatch: React.PropTypes.func,
		expandedItem: React.PropTypes.object,
		opened: React.PropTypes.string,
	};

	componentDidMount() {
		const { expandedItem, claimNumber, dispatch } = this.props;
        this.setState({ showTable: false });

		if (claimNumber && !expandedItem) {
			dispatch(fetchClaims({ claimNumber }));
		}
	}

	async componentWillUnmount() {
		const { dispatch } = this.props
		dispatch(clearClaimWizardPackages())
		await dispatch(resetClaimWizard())
	}

	handleSearch = data => {
        const { dispatch } = this.props;
		return dispatch(fetchClaims(data)).then(data => {
			this.setState({ showTable: true }, () => {
                this.forceUpdate();
            });
			return data;
		});
	};

	zoomClaim = item => {
		const { dispatch } = this.props;
		dispatch(setOpened(item.claimNumber));
	};

	setActiveSubtitle = subtitle => {
		this.setState(
			prevState => ({
				activeSubtitle: prevState.activeSubtitle === subtitle ? 'schade' : subtitle,
			}),
			() => {
				if (this.state.activeSubtitle === 'digital') {
					this.props.dispatch(fetchAllClaimWizardPackages({ createdByBroker: "true" }))
				} else if (this.state.activeSubtitle === 'schade') {
					this.props.dispatch(clearClaimWizardPackages())
				}
			}
		)
	}

	render() {
		const { claims, expandedItem, opened, claimWizardPackages } = this.props
		const { showTable, activeSubtitle  } = this.state

		let output;
		switch (activeSubtitle) {
		  case 'schade':
			output = (
			  <div>
				<ClaimsForm onSubmit={this.handleSearch} initialValues={{ state: '' }} />
				{showTable && claims && <ClaimResults data={claims} zoomTo={this.zoomClaim} />}
			  </div>
			);
			break;
		  case 'digital':
			output = <DigitalClaimTable claims={claimWizardPackages} onCloseMethod={() => this.props.dispatch(fetchAllClaimWizardPackages({ createdByBroker: "true" }))} />;
			break;
		  default:
			output = <div>{_('Unknown subtitle')}</div>;
			break;
		}
	
		return (
		  <div className={styles.claimsMain}>
			<div className={`${styles.claimsSearchContainer} ${opened ? styles.hidden : 'visible'}`}>
			  <div className="main-title-div">
				  <h2 className="main-title">{_('title')}</h2>
				  <div className={styles.subtitles}>
					<SubNav
					  currentId={activeSubtitle}
					  items={{
						schade: _('subtitle'),
						digital: _('digitalTable'),
					  }}
					  onChange={this.setActiveSubtitle}
					/>
				  </div>
			  </div>
			  {output}
			</div>
	
			{expandedItem && (
			  <div className={styles.claimsZoomContainer}>
				<ClaimsZoom data={expandedItem} />
			  </div>
			)}
		  </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/claims/index.jsx